exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MyWork-module__wrapper___3JzRy{display:grid;gap:1.5rem}", ""]);

// exports
exports.locals = {
	"wrapper": "MyWork-module__wrapper___3JzRy"
};